import { message } from "antd";
import { connect } from "react-redux";
import * as React from "react";
import { Row, Col, Checkbox } from "antd";
import Model from "viewModel";
// const CheckboxGroup = Checkbox.Group;

interface IScreeningItem {
  // 传递当前元素对象
  onRef: any;
  // 获取筛选项
  getItemsList: any;
  // 更新筛选项
  setScreeningItem: any;
}

// 筛选项
class ScreeningItem extends React.Component<IScreeningItem, any> {
  state = {
    // 字段列表
    fieldList: [],
    checkedList: [],
    indeterminate: true,
    checkAll: false
  };

  constructor(props: IScreeningItem) {
    super(props);
    this.props.onRef(this);
  }

  // 组件完成加载后触发的事件
  componentDidMount() {
    this.props.getItemsList();
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    const data = nextProps.screeningItem;
    // 只有在字段列表没有值时才执行以下逻辑
    if (prevState.fieldList.length === 0 && data) {
      let fieldList: any = [],
        checkedList: any = [];
       
      for (const item in data) {
        if (data[item] == 1) {
          // 当字段是选中状态时添加到选中列表中
          checkedList.push(item);
        }
        // 更新字段列表
        fieldList.push(item);
      }

      // 当列表项的数目和选中列表的数目相等时把状态更新为全选
      if (fieldList.length === checkedList.length) {
        prevState.checkAll = true;
      }
      return {
        fieldList,
        checkedList
      };
    } else {
      return null;
    }
  }

  onChange = checkedList => {
    this.setState({
      checkedList,
      indeterminate:
        !!checkedList.length &&
        checkedList.length < this.state.fieldList.length,
      checkAll: checkedList.length === this.state.fieldList.length
    });
  };

  onCheckAllChange = e => {
    const data = this.state.fieldList;
    this.setState({
      checkedList: e.target.checked ? data : [],
      indeterminate: false,
      checkAll: e.target.checked
    });
  };

  submit = callback => {
    const testModel = this.state.fieldList,
      checkList: any = this.state.checkedList;
    let params: any = {};

    for (const item of testModel) {
      if (checkList.indexOf(item) != -1) {
        params[item] = 1;
      } else {
        params[item] = 0;
      }
    }
    // 请求筛选项接口
    this.props.setScreeningItem({
      ...params,
      callback: res => {
        if (!res.error) {
          message.success("编辑筛选项成功");
          // 回调函数 提供给依赖于该接口返回值的功能
          callback && callback();
        } else {
          message.error(res.res.msg || "编辑筛选项失败");
        }
      }
    });
    return true;
  };

  // 格式化数据
  formatOptions = () => {
    const data = this.state.fieldList;
    if (data) {
      let list: any = [];
      let rowOptions: any = [];
      let count = 0,
        isNotNewRow = false,
        label: any = "",
        sortField: any,
        // 用于排序的字段列表
        sortFiedList: any = [];

      for (const item of data) {
        // 根据字段名字获取标签名称
        sortField = Model.TestModel.mapToLabel(item);
        // 如果匹配不到字段则不做处理
        if (sortField === null) {
          continue;
        }
        sortFiedList.push({ name: item, ...sortField });
      }

      // 由于服务端返回的字段顺序和界面上显示的顺序不一致，所以需要对字段进行排序
      // 升序排序
      sortFiedList.sort((prev, next) => {
        return prev.sort - next.sort;
      });

      for (const item of sortFiedList) {
        // 根据字段名字获取标签名称
        label = item.label; //orderModel.mapToLabel(item);
        count++;

        // 这里配置的是一行显示的字段数
        isNotNewRow = count % 5 === 0;

        rowOptions.push(
          <Col key={count} span={isNotNewRow === false ? 5 : 4}>
            <Checkbox value={item.name}>{label}</Checkbox>
          </Col>
        );

        // 这里创建数据行
        if (isNotNewRow) {
          list.push(
            <Row key={"row_" + count / 5} style={{ marginBottom: 10 }}>
              {rowOptions}
            </Row>
          );
          rowOptions = [];
        }
      }

      // 最后一行的数据
      if (rowOptions.length > 0)
        list.push(<Row key={"row_" + (count / 5 + 1)}>{rowOptions}</Row>);
      return list;
    }
    return [];
  };

  allCheckboxStyle = {
    borderBottom: "1px solid #E9E9E9",
    marginBottom: 10,
    paddingBottom: 10
  };

  render() {
    return (
      <React.Fragment>
        <div style={this.allCheckboxStyle}>
          <Checkbox
            // indeterminate={this.state.indeterminate}
            onChange={this.onCheckAllChange}
            checked={this.state.checkAll}
          >
            全选
          </Checkbox>
        </div>
        <Checkbox.Group
          value={this.state.checkedList}
          onChange={this.onChange}
          style={{ width: "100%" }}
        >
          {this.formatOptions()}
        </Checkbox.Group>
      </React.Fragment>
    );
  }
}

// const mapState = state => ({});

const mapDispatch = dispatch => {
  return {
    // 编辑筛选项
    setScreeningItem: dispatch.orderInfo.setScreeningItem
    // // 获取筛选项
    // getItemsList: dispatch.orderInfo.getItemsList
  };
};

export default connect(
  null,
  mapDispatch
)(ScreeningItem);
